import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ConfirmCancelModal = ({ isOpen, onConfirm, onCancel }) => {
    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.18 }}
                    style={{
                        position: 'fixed', inset: 0,
                        backgroundColor: 'rgba(0,0,0,0.55)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        zIndex: 9999,
                    }}
                >
                    <motion.div
                        initial={{ scale: 0.88, opacity: 0, y: 20 }}
                        animate={{ scale: 1, opacity: 1, y: 0 }}
                        exit={{ scale: 0.88, opacity: 0, y: 20 }}
                        transition={{ duration: 0.22, ease: [0.4, 0, 0.2, 1] }}
                        style={{
                            background: 'white',
                            borderRadius: '1.5rem',
                            padding: '2.5rem 2rem',
                            maxWidth: '420px',
                            width: '90%',
                            textAlign: 'center',
                            boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
                        }}
                    >
                        <div style={{
                            width: 64, height: 64,
                            background: '#fee2e2',
                            borderRadius: '50%',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            margin: '0 auto 1.25rem',
                        }}>
                            <svg width="32" height="32" fill="none" stroke="#DC2626" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5}
                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                        </div>

                        <h2 style={{ fontSize: '1.5rem', fontWeight: 800, color: '#1a1a1a', margin: '0 0 0.5rem' }}>
                            ¿Cancelar pedido?
                        </h2>
                        <p style={{ fontSize: '1rem', color: '#6b7280', margin: '0 0 2rem' }}>
                            Se eliminarán todos los productos del carrito.
                        </p>

                        <div style={{ display: 'flex', gap: '0.75rem' }}>
                            <button
                                onClick={onCancel}
                                style={{
                                    flex: 1, padding: '0.875rem',
                                    background: 'white', color: '#374151',
                                    border: '2px solid #e5e7eb', borderRadius: '50px',
                                    fontSize: '1rem', fontWeight: 700, cursor: 'pointer',
                                }}
                            >
                                Volver
                            </button>
                            <button
                                onClick={onConfirm}
                                style={{
                                    flex: 1, padding: '0.875rem',
                                    background: '#DC2626', color: 'white',
                                    border: 'none', borderRadius: '50px',
                                    fontSize: '1rem', fontWeight: 700, cursor: 'pointer',
                                }}
                            >
                                Cancelar pedido
                            </button>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default ConfirmCancelModal;
